

// ForumPage.jsx
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Swal from 'sweetalert2'
import { useSelector } from "react-redux";

const API_BASE = "https://www.mikeconnect.com/mc_api";

const ForumPage = ({ user }) => {
  const [posts, setPosts] = useState([]);
  const [newMsg, setNewMsg] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [editingPost, setEditingPost] = useState(null);
  const [editContent, setEditContent] = useState("");
  const chatEndRef = useRef(null);
  const chatAreaRef = useRef(null);

    const userInfo = useSelector((state) => {
    if (state.adminInfo) return state.adminInfo;
    if (state.userInfo) return state.userInfo;
    return null;
  });
  

  console.log(posts)

  // fetch posts
  const fetchForumData = async () => {
    try {
      const res = await fetch(`${API_BASE}/get_forum_data.php?_=${Date.now()}`, { cache: "no-store" });
      const data = await res.json();
      if (data.success) setPosts(data.posts || []);
    } catch (err) {
      console.error("Fetch posts error:", err);
    }
  };

  useEffect(() => {
    fetchForumData();
    const interval = setInterval(fetchForumData, 4000);
    return () => clearInterval(interval);
  }, []);

  // send a message
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMsg.trim()) return;

    if(!userInfo){
        Swal.fire({text:"Please login to start posting"})
        return;
    }

    const formData = new FormData();
    formData.append("user_id", user.id);
    formData.append("user_type", user.role ? user.role.toLowerCase() : "user1");
    formData.append("content", newMsg);
    if (replyTo) formData.append("reply_to", replyTo.id);

    try {
      const res = await fetch(`${API_BASE}/forum_add_post.php`, { method: "POST", body: formData });
      const data = await res.json();
      if (data.success) {
        setNewMsg("");
        setReplyTo(null);
        await fetchForumData();
        if (data.post_id) {
          setTimeout(() => {
            const el = document.getElementById(`msg-${data.post_id}`);
            el?.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 300);
        }
      }
    } catch (err) {
      console.error("Network error on send:", err);
    }
  };

  // scroll + highlight
  const scrollToMessage = (id) => {
    const el = document.getElementById(`msg-${id}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("highlight");
      setTimeout(() => el.classList.remove("highlight"), 1400);
    }
  };

  const onReplyClick = (post) => {
    setReplyTo({ id: post.id, content: post.content, email: post.email });
    document.querySelector("#chat-input")?.focus();
  };

  // --- NEW: Edit post ---
  const onEditClick = (post) => {
    setEditingPost(post);
    setEditContent(post.content);
  };

  const saveEdit = async (postId) => {
    if (!editContent.trim()) return alert("Message cannot be empty.");
    const formData = new FormData();
    formData.append("post_id", postId);
    formData.append("user_id", user.id);
    formData.append("user_type", user.role ? user.role.toLowerCase() : "user1");
    formData.append("content", editContent);

    try {
      const res = await fetch(`${API_BASE}/forum_edit_post.php`, { method: "POST", body: formData });
      const data = await res.json();
      if (data.success) {
        setEditingPost(null);
        setEditContent("");
        await fetchForumData();
      } else {
        alert(data.error || "Unable to edit post.");
      }
    } catch (err) {
      console.error("Error editing post:", err);
    }
  };

  const cancelEdit = () => {
    setEditingPost(null);
    setEditContent("");
  };





const deleteMessage = async (id) => {
  Swal.fire({
    title: 'Delete message?',
    text: 'Are you sure you want to delete this message? This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#5B6CFF',
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel',
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    const formData = new FormData();
    formData.append("post_id", id);
    formData.append("user_id", user.id);
    formData.append(
      "user_type",
      user.role ? user.role.toLowerCase() : "user1"
    );

    try {
      const res = await fetch(`${API_BASE}/forum_delete_post.php`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        setPosts((prev) => prev.filter((p) => p.id !== id));

        Swal.fire({
          icon: 'success',
          title: 'Deleted',
          text: 'The message has been deleted.',
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Delete failed',
          text: data.error || 'Failed to delete post.',
        });
      }
    } catch (err) {
      console.error('Delete error:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while deleting the message.',
      });
    }
  });
};






  // --- Render ---
  return (
    <ChatWrapper>
      <Title>💬 MIKE CONNECT FORUM</Title>

      <ChatArea ref={chatAreaRef}>
        {posts.sort((a, b) => a.id - b.id).map((m) => {
          const mine = m.user_id === user?.id;
          const createdTime = new Date(m.created_at);
          const now = new Date();
          const canEdit = mine && (now - createdTime) / 60000 < 5;

          return (
            <MsgBubble key={m.id} id={`msg-${m.id}`} $mine={mine}>
              <MsgHeader>{(m.email || "unknown").split("@")[0]} 
          
  {m.user_type === "admin" ?
      <span
  style={{
    display: "inline-block",
    background: "linear-gradient(135deg, #5B6CFF, #7C4DFF)",
    color: "#fff",
    fontSize: "0.6rem",
    fontWeight: 600,
    padding: "1px 6px",
    borderRadius: "8px",
    marginLeft: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  }}
>
  {m.user_type}
  </span>
   : ""}


                </MsgHeader>

              {m.reply_to && (
                <ReplyPreview onClick={() => scrollToMessage(m.reply_to)}>
                  <small>↪ Reply to:</small>
                  <div className="preview-text">{(m.replied_content || "").slice(0, 80)}</div>
                </ReplyPreview>
              )}

              {/* Editing mode */}
              {editingPost?.id === m.id ? (
                <div>
                  <EditInput
                    value={editContent}
                    onChange={(e) => setEditContent(e.target.value)}
                  />
                  <EditActions>
                    <button onClick={() => saveEdit(m.id)}>💾 Save</button>
                    <button onClick={cancelEdit}>✕ Cancel</button>
                  </EditActions>
                </div>
              ) : (
                <MsgText>{m.content}</MsgText>
              )}

              <FooterRow>
                <MsgTime>{new Date(m.created_at).toLocaleTimeString()}</MsgTime>
                <MsgTime>{m.updated_at?"Edited":""}</MsgTime>
                <div>
                  <ReplyLink onClick={() => onReplyClick(m)}>Reply</ReplyLink>
                  {canEdit && (
                    <EditLink onClick={() => onEditClick(m)}>Edit</EditLink>
                  )}
                    {m.user_id === user?.id && (
      <DeleteLink onClick={() => deleteMessage(m.id)}>🗑 Delete</DeleteLink>
    )}
                </div>
              </FooterRow>
            </MsgBubble>
          );
        })}
        <div ref={chatEndRef} />
      </ChatArea>

      <InputArea onSubmit={sendMessage}>
        {replyTo && (
          <ReplyBar>
            <div>
              Replying to <strong>{replyTo.email?.split("@")[0] || "unknown"}</strong>:
              <div className="snippet">
                {replyTo.content.slice(0, 50)}
                {replyTo.content.length > 50 ? "..." : ""}
              </div>
            </div>
            <button type="button" onClick={() => setReplyTo(null)}>✕</button>
          </ReplyBar>
        )}
        <InputRow>
          <ChatInput
            id="chat-input"
            type="text"
            placeholder={replyTo ? `Replying to ${replyTo.email.split("@")[0]}...` : "Type a message"}
            value={newMsg}
            onChange={(e) => setNewMsg(e.target.value)}
          />
          <SendBtn type="submit">Send</SendBtn>
        </InputRow>
      </InputArea>
    </ChatWrapper>
  );
};

export default ForumPage;

/* ====== Styles ====== */
const ChatWrapper = styled.div`
//   margin: 12px auto;
//   max-width: 820px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
  background: #ece5dd;
  @media(max-width:884px){
   height: 90vh;
   padding-top:15px;
  }
`;
const Title = styled.h3`margin: 8px 12px; color: #075e54; font-size:0.9rem`;
const ChatArea = styled.div`
  flex: 1; overflow-y: auto; padding: 16px;
  display: flex; flex-direction: column; gap: 10px;
  .highlight { box-shadow: 0 0 0 5px green inset; transition: box-shadow 1s ease; }
`;
const MsgBubble = styled.div`
  align-self: ${(p) => (p.$mine ? "flex-end" : "flex-start")};
  background: ${(p) => (p.$mine ? "#dcf8c6" : "#fff")};
  padding: 2px 10px; border-radius: 12px; max-width: 78%;
`;
const MsgHeader = styled.div`font-weight: 700; color: #075e54; margin-bottom: 3px;`;
const ReplyPreview = styled.div`
  background: #f2f2f2; border-left: 3px solid #34b7f1; padding: 6px 8px;
  margin-bottom: 8px; border-radius: 6px; cursor: pointer;
  .preview-text { color: #333; font-size: 13px; margin-top: 4px; }
`;
const MsgText = styled.div`font-size: 15px; color: #111;`;
const FooterRow = styled.div`
  display: flex; gap: 12px; justify-content: space-between;
  align-items: center; margin-top: 4px;
`;
const MsgTime = styled.small`color: #666; font-size: 12px;`;
const ReplyLink = styled.span`color: #34b7f1; font-size: 13px; cursor: pointer; margin-left: 8px;`;
const EditLink = styled.span`color: #f39c12; font-size: 13px; cursor: pointer; margin-left: 12px;`;
const InputArea = styled.form`background: #fff; padding: 8px; border-top: 1px solid #ddd;`;
const ReplyBar = styled.div`
  background: #fafafa; border-left: 4px solid #34b7f1; padding: 8px;
  margin-bottom: 8px; display: flex; justify-content: space-between;
  align-items: center;
  .snippet { color: #444; margin-top: 4px; font-size: 13px; }
  button { background: transparent; border: none; font-size: 18px; cursor: pointer; color: #666; }
`;
const InputRow = styled.div`display: flex; gap: 8px; align-items: center;`;
const ChatInput = styled.input`flex: 1; padding: 10px 14px; border-radius: 24px; border: 1px solid #ccc; font-size: 14px;`;
const SendBtn = styled.button`background: #075e54; color: white; border-radius: 20px; padding: 8px 14px; border: none; cursor: pointer;`;
const EditInput = styled.textarea`
  width: 100%; border: 1px solid #ccc; border-radius: 8px;
  padding: 8px; margin-top: 4px; font-size: 14px; resize: none;
`;
const EditActions = styled.div`
  display: flex; gap: 10px; margin-top: 4px;
  button { border: none; border-radius: 6px; padding: 4px 8px; cursor: pointer; }
  button:first-child { background: #075e54; color: white; }
  button:last-child { background: #ccc; color: black; }
`;


const DeleteLink = styled.span`
  color: #d9534f;
  font-size: 13px;
  cursor: pointer;
  margin-left: 10px;
`;
